
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/pages",
      function () {
        return require("private-next-pages/sitemap/pages.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/pages"])
      });
    }
  